import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { SceneRegister, Scene } from '../../Scenes/types';
import { Model } from '../useModelState';
import PCSpool from '../../MineModel/Spools/PCSpool';

export interface ISceneManagerContext {
  state: {
    currentScene: Scene | undefined;
    drawerOpen: boolean;
    shouldSaveView: boolean;
    shouldLoadView: boolean;
    shouldEditNode: boolean;
    spoolToEdit: PCSpool | undefined;
    addStopeMode: boolean;
    shouldAutoRecipeCreation: boolean;
    shouldAutoRecipeList: boolean;
    shouldAutoPourCreation: boolean;
    shouldAutoPourList: boolean;
  },
  actions: {
    setScene: (scene: SceneRegister, model?: Model) => void;
    sceneActive: () => boolean;
    display: (model: Model) => JSX.Element | undefined;
    sideDrawerContent?: (model: Model) => JSX.Element | undefined;
    topToolbarContent?: (model: Model) => JSX.Element | undefined;
    setDrawerOpen: (isOpen: boolean) => void;
    saveView: () => void;
    loadView: () => void;
    editNodes: (isOpen: boolean) => void;
    editSpool: (spool: PCSpool | undefined) => void;
    setAddStopeMode: (mode: boolean) => void;
    setAutoRecipeCreationOpen: (isOpen: boolean) => void;
    setAutoRecipeListOpen: (isOpen: boolean) => void;
    setAutoPourCreationOpen: (isOpen: boolean) => void;
    setAutoPourListOpen: (isOpen: boolean) => void;
    navigate: NavigateFunction;
    refreshScene: () => void;
  }
}

const SceneManagerContext = React.createContext<ISceneManagerContext | undefined>(undefined);

export default SceneManagerContext;
